module.exports = __webpack_public_path__ + "images/smart_lists_modal.0cd71886a4c1f63358c36cf5de27aeab.png";